// browser.js

exports.encode = require("./encode").encode;
exports.decode = require("./decode").decode;

exports.Encoder = require("./encoder").Encoder;
exports.Decoder = require("./decoder").Decoder;

exports.createCodec = require("./ext").createCodec;
exports.codec = require("./codec").codec;



//////////////////
// WEBPACK FOOTER
// ./node_modules/msgpack-lite/lib/browser.js
// module id = 1374
// module chunks = 10